import ProductTimeSeriesPqChart from './ProductTimeSeriesPqChart';
export default ProductTimeSeriesPqChart;
